<template>
  <v-content>
    <v-container>
      <v-layout justify-center class="mt-5">
        <v-flex xs12 sm8 md5>
          <div v-if="!token">
            <v-alert type="error">
              This link is invalid. Please request a new password reset.
            </v-alert>
            <router-link :to="{ name: 'Provider-Forgot-Password' }"
              >Request a reset</router-link
            >
          </div>

          <v-form v-else ref="form" @submit.prevent="submit" lazy-validation>
            <h2 class="headline pb-2">Set a New Password</h2>
            <p class="body-1 pb-2">Enter your new password below.</p>

            <v-text-field
              v-model="password"
              label="New Password"
              solo
              flat
              type="password"
              :rules="[required, minLength]"
              hint="Minimum 8 characters"
              persistent-hint
              :disabled="loading || done"
            />

            <v-text-field
              v-model="confirmPassword"
              label="Confirm New Password"
              solo
              flat
              type="password"
              :rules="[required, passwordsMatch]"
              :disabled="loading || done"
            />

            <v-alert v-if="errorMessage" type="error" class="mb-3">
              {{ errorMessage }}
            </v-alert>
            <v-alert v-if="done" type="success" class="mb-3">
              Your password has been updated. You can now
              <router-link :to="{ name: 'Provider-Login' }">log in</router-link
              >.
            </v-alert>

            <v-btn
              v-if="!done"
              depressed
              color="secondary"
              class="white--text"
              type="submit"
              :loading="loading"
            >
              Update Password
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";

const baseUrl =
  (window.location.hostname === "localhost"
    ? "http://" + window.location.hostname + ":3000"
    : window.location.origin) + "/api";

export default {
  name: "ProviderResetPassword",
  data() {
    return {
      password: "",
      confirmPassword: "",
      loading: false,
      done: false,
      errorMessage: "",
      token: this.$route.query.token || null
    };
  },
  methods: {
    required: v => !!v || "This field is required.",
    minLength: v =>
      (v && v.length >= 8) || "Password must be at least 8 characters.",
    passwordsMatch() {
      return (
        this.password === this.confirmPassword || "Passwords do not match."
      );
    },

    async submit() {
      if (!this.$refs.form.validate()) return;
      this.errorMessage = "";
      this.loading = true;
      try {
        await axios.post(`${baseUrl}/providers/reset-password`, {
          token: this.token,
          password: this.password
        });
        this.done = true;
      } catch (err) {
        const msg =
          err.response && err.response.data && err.response.data.message;
        this.errorMessage =
          msg || "Failed to reset password. The link may have expired.";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
form {
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: 0.5em;
}
</style>
